import { call, put } from "redux-saga/effects";
import { api, notify } from "services";
import { requestErrorHandler } from "utils";
import { ListTransportFilesActions } from "store/ducks/transport-files";

export function* listTransportFilesRequest(action: any) {
  try {
    const { query: id, onSuccess } = action;
    const { data } = yield call(api.get, `/transport-files/${id}`);

    yield put(ListTransportFilesActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(ListTransportFilesActions.failure(errorMessage));
  }
}
